import './Toggle.css';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

function Toggle({ label = '', defaultValue = true, isDisabled = false, onChange, className = '' }) {
  const [toggle, setToggle] = useState(false);

  const { t } = useTranslation();

  const triggerToggle = (e) => {
    if (isDisabled) {
      return;
    }
    setToggle(!toggle);
    onChange(!toggle);
  };

  const toggleClasses = classNames(
    'wrg-toggle',
    {
      'wrg-toggle--checked': toggle
    },
    className,
  );

  const containerBackground = classNames('wrg-toggle-container', {
    'wrg-toggle-container--checked': toggle,
    'wrg-toggle-container--unchecked': !toggle,
    'wrg-toggle-container--disabled': isDisabled,
  });

  useEffect(() => {
    setToggle(defaultValue);
  }, [defaultValue]);

  return (
    <div>
      <p className="text-sm font-extrabold">{ t(label) }:</p>
      <div onClick={(e) => triggerToggle(e)} className={toggleClasses}>
        <div className={containerBackground}>
          <div className="wrg-toggle-check">
            <span>ON</span>
          </div>
          <div className="wrg-toggle-uncheck">
            <span>OFF</span>
          </div>
        </div>
        <div className="wrg-toggle-circle"></div>
        <input className="wrg-toggle-input" type="checkbox" aria-label="Toggle Button" />
      </div>
    </div>
  );
}

export default Toggle;
